const createCache = () => {
    let cache = null;

    return {
        get: () => cache,
        set: (data) => {
            cache = data;
        },
        clear: () => {
            cache = null;
        },
    };
};

export default createCache;
